module.exports = __webpack_public_path__ + "img/logo_3.1ee438ef.svg";